<template lang="pug">
.save-content
  v-slide-y-reverse-transition(hide-on-leave)
    .toolbar-content(v-if='show && isToolbarContent')
      b {{ $t("unpublishedChanges") }}
      v-divider.mx-3(inset vertical)
      v-btn(depressed color='primary' @click='$emit(`submit`)' :disabled='disabled' :loading='loading' v-t='"publish"')
      v-btn(flat @click='$emit(`cancel`)' :disabled='loading' v-t='"discard"')

  v-snackbar(:value='show' v-if='!isToolbarContent' :timeout='0' right bottom auto-height)
    .dot-text.mr-3 {{ $t("unpublishedChanges") }}
    .btns
      v-btn(depressed color='primary' @click='$emit(`submit`)' :disabled='disabled' :loading='loading' v-t='"publish"')
      v-btn(flat @click='$emit(`cancel`)' v-t='"discard"')
</template>

<script>
export default {
  name: 'ToolbarSaveContent',
  props: {
    show: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 根據裝置大小或滾動位置 決定顯示預設發佈按鈕樣式或 toolbar 樣式
    isToolbarContent () {
      return this.$vuetify.breakpoint.smAndUp && !(this.offsetTop > 80)
    },
    offsetTop () {
      return this.$store.state.offsetTop
    },
  },
}
</script>

<style scoped lang="sass">
.save-content
  transform: none

.toolbar-content
  display: flex
  align-items: center
  flex-wrap: no-wrap

.dot-text
  display: inline-block
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.btns
  white-space: nowrap
  .v-btn
    +px(1.5rem)
    +mx(.4rem)

.v-snack--auto-height::v-deep
  .v-snack__content
    margin-bottom: env(safe-area-inset-bottom)
</style>

<i18n src="@/lang/components/toolbarSaveContent.json"></i18n>
